module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.selectedTab >= 0) ? _c('v-dialog', {
    attrs: {
      "fullscreen": !_vm.newPairingFlow || _vm.selectedTab === 1,
      "max-width": _vm.modalMaxWidth,
      "hide-overlay": !_vm.newPairingFlow,
      "persistent": "",
      "scrollable": "",
      "no-click-animation": !_vm.newPairingFlow
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticStyle: {
      "max-height": "64px"
    },
    attrs: {
      "dark": "",
      "flat": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.modalTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.closeModel
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [(!_vm.newPairingFlow) ? _c('div', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "50px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "sm": "4",
      "md": "4",
      "lg": "4",
      "align": "center"
    }
  }, [_c('div', [_c('v-img', {
    staticClass: "profile-pic",
    attrs: {
      "src": _vm.profilePicture,
      "width": "130px",
      "height": "130px"
    }
  })], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "d-none d-sm-flex",
    attrs: {
      "cols": "12",
      "xs": "12",
      "sm": "8",
      "md": "8",
      "lg": "8"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "40px",
      "margin-bottom": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(("" + (_vm.influencer.userHandle))))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(((_vm.influencer.followers) + " followers")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(((_vm.influencer.audience_credibility) + " AC")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(((_vm.influencer.engagement_rate) + " ER")))]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.fullName))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [(_vm.influencer.status === this.pairingStatus.ACCEPTED.value) ? _c('div', [(_vm.influencer.agreement) ? _c('div', [(_vm.influencer.agreement.isAgree !== undefined) ? _c('div', [(_vm.influencer.agreement.isAgree) ? _c('v-chip', {
    attrs: {
      "color": "success",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                            Agreed\n                          ")]) : _c('v-chip', {
    attrs: {
      "color": "red",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                            Declined\n                          ")])], 1) : _c('v-chip', {
    attrs: {
      "color": _vm.getStatusColor(_vm.influencer.status),
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.influencer.status_description) + "\n                        ")])], 1) : _c('v-chip', {
    attrs: {
      "color": _vm.getStatusColor(_vm.influencer.status),
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.influencer.status_description) + "\n                      ")])], 1) : _c('v-chip', {
    attrs: {
      "color": _vm.getStatusColor(_vm.influencer.status),
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.influencer.status_description) + "\n                      ")])], 1)])]), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex d-sm-none",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "40px",
      "margin-bottom": "50px",
      "width": "100%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(("" + (_vm.influencer.userHandle))))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(((_vm.influencer.followers) + " followers")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(((_vm.influencer.audience_credibility) + " AC")))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(((_vm.influencer.engagement_rate) + " ER")))]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.fullName))]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_c('v-chip', {
    attrs: {
      "color": _vm.getStatusColor(_vm.influencer.status),
      "small": "",
      "dark": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.influencer.status_description) + "\n                      ")])], 1)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pendingStatus && !_vm.acceptedStatus && !_vm.notAcceptedStatus),
      expression: "!pendingStatus && !acceptedStatus && !notAcceptedStatus"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.approvedClick()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Accepted\n                ")], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.notAcceptedStatus),
      expression: "!notAcceptedStatus"
    }],
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.notAccepted()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v("Not Accepted\n                ")], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notInterestedStatus),
      expression: "notInterestedStatus"
    }],
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "primary"
    }
  }, [_vm._v("\n                  Convince"), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-help")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pendingStatus),
      expression: "pendingStatus"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.approvedClick()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Accepted\n                ")], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.notAcceptedStatus),
      expression: "!notAcceptedStatus"
    }],
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.notAccepted()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v("Not Accepted\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.followUp()
      }
    }
  }, [_vm._v("\n                  Follow Up"), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-help")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.newPairingFlow) ? _c('hr', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "width": "90%"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-tabs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabShow),
      expression: "tabShow"
    }],
    attrs: {
      "centered": ""
    },
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('v-tabs-slider'), _vm._v(" "), _c('v-tab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newPairingFlow),
      expression: "!newPairingFlow"
    }]
  }, [_vm._v("\n                Detail\n              ")]), _vm._v(" "), (_vm.inquiryStatus) ? _c('v-tab', [_vm._v("\n                Q&A\n              ")]) : _vm._e(), _vm._v(" "), (_vm.notInterestedStatus) ? _c('v-tab', [_vm._v("\n                Reject reasons\n              ")]) : _vm._e(), _vm._v(" "), _c('v-tab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.interestedStatus || _vm.pendingStatus || _vm.acceptedStatus) && !_vm.newPairingFlow),
      expression: "(interestedStatus || pendingStatus || acceptedStatus) && !newPairingFlow"
    }]
  }, [_vm._v("\n                Brief detail\n              ")]), _vm._v(" "), _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "justify": "center",
      "align": "start"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": _vm.newPairingFlow ? 12 : 6,
      "lg": _vm.newPairingFlow ? 12 : 6
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("Campaign")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                          " + _vm._s(("" + (_vm.influencer.CampaignName))) + "\n                          "), _c('v-divider'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.influencer.deliverables),
      expression: "this.influencer.deliverables"
    }]
  }, [_c('h4', [_vm._v("Deliverables")]), _vm._v(" "), _c('lu', [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfTikTokPost > 0),
      expression: "numberOfTikTokPost > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfTikTokPost))]), _vm._v(" x TikTok Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfXHSPost > 0),
      expression: "numberOfXHSPost > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfXHSPost))]), _vm._v(" x XHS Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfPost > 0),
      expression: "numberOfPost > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfPost))]), _vm._v(" x Instagram Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfCarousels > 0),
      expression: "numberOfCarousels > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfCarousels))]), _vm._v(" x Instagram Carousels Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfStories > 0),
      expression: "numberOfStories > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfStories))]), _vm._v(" x Instagram Stories")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfVideo > 0),
      expression: "numberOfVideo > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfVideo))]), _vm._v(" x Instagram Video")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfIGReels > 0),
      expression: "numberOfIGReels > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfIGReels))]), _vm._v(" x Instagram Reel")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfLinkedInPosts > 0),
      expression: "numberOfLinkedInPosts > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfLinkedInPosts))]), _vm._v(" x LinkedIn Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfXPosts > 0),
      expression: "numberOfXPosts > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfXPosts))]), _vm._v(" x X (Twitter) Post")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfYoutube > 0),
      expression: "numberOfYoutube > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfYoutube))]), _vm._v(" x Youtube")]), _vm._v(" "), (_vm.isLoadingWhitelist) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.influencer.deliverables.loading_whitelisting))]), _vm._v(" x Loading/Whitelisting")]) : _vm._e(), _vm._v(" "), (_vm.isExclusivity) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.influencer.deliverables.exclusivity))]), _vm._v(" x Exclusivity")]) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfPA > 0),
      expression: "numberOfPA > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfPA))]), _vm._v(" x Physical Attendance")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.numberOfOA > 0),
      expression: "numberOfOA > 0"
    }]
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberOfOA))]), _vm._v(" x Online Attendance")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [(_vm.influencer.deliverables) ? _c('div', _vm._l((_vm.influencer.deliverables.custom), function(custom, pIndex) {
    return _c('v-list', {
      key: pIndex,
      staticClass: "pt-0 pb-0"
    }, [_c('v-list-item', {
      staticClass: "multiple-fields-area pt-0 pb-0"
    }, [_c('div', {
      staticClass: "d-flex flex-row pt-2"
    }, [_c('div', [_c('v-text-field', {
      staticClass: "mutliple-field px-1",
      attrs: {
        "dense": "",
        "outlined": "",
        "hide-details": "",
        "placeholder": "Custom Deliverables"
      },
      model: {
        value: (custom.label),
        callback: function($$v) {
          _vm.$set(custom, "label", $$v)
        },
        expression: "custom.label"
      }
    })], 1), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "type": "number",
        "dense": "",
        "outlined": "",
        "hide-details": "",
        "min": "1"
      },
      model: {
        value: (custom.value),
        callback: function($$v) {
          _vm.$set(custom, "value", _vm._n($$v))
        },
        expression: "custom.value"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "pt-5",
      attrs: {
        "color": "danger",
        "text": "",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.influencer.deliverables.custom.splice(pIndex, 1)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("mdi-delete-forever")])], 1)], 1)])], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "float-left"
  }, [_c('v-list-item', {
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.addCustom()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Custom Deliverable\n                                ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h4', [_vm._v("Additional Line Items")]), _vm._v(" "), (_vm.influencer.payout_details) ? _c('div', {
    staticClass: "clearfix"
  }, [(_vm.influencer.payout_details.boostingFees) ? _c('div', _vm._l((_vm.influencer.payout_details.boostingFees), function(boostingFee, bIndex) {
    return _c('v-list', {
      key: bIndex,
      staticClass: "pt-0 pb-0"
    }, [_c('v-list-item', {
      staticClass: "multiple-fields-area pt-0 pb-0"
    }, [_c('div', {
      staticClass: "d-flex flex-row pt-2"
    }, [_c('div', [_c('v-text-field', {
      staticClass: "mutliple-field px-1",
      attrs: {
        "dense": "",
        "outlined": "",
        "hide-details": "",
        "placeholder": "E.g. Boosting Fee"
      },
      model: {
        value: (boostingFee.label),
        callback: function($$v) {
          _vm.$set(boostingFee, "label", $$v)
        },
        expression: "boostingFee.label"
      }
    })], 1), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "type": "number",
        "dense": "",
        "outlined": "",
        "hide-details": "",
        "min": "0",
        "step": "0.01"
      },
      on: {
        "input": function($event) {
          return _vm.updateTotalPayoutWithBoostingFee(boostingFee.value)
        }
      },
      model: {
        value: (boostingFee.value),
        callback: function($$v) {
          _vm.$set(boostingFee, "value", _vm._n($$v))
        },
        expression: "boostingFee.value"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "pt-5",
      attrs: {
        "color": "danger",
        "text": "",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteBoostingFees(bIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("mdi-delete-forever")])], 1)], 1)])], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "float-left"
  }, [_c('v-list-item', {
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.addBoostingFee()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Additional Line Item\n                                ")], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "pa-0"
  }, [_c('li', {
    staticClass: "mt-2",
    staticStyle: {
      "list-style": "none"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.deliverableNotes),
      callback: function($$v) {
        _vm.deliverableNotes = $$v
      },
      expression: "deliverableNotes"
    }
  })], 1)]), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('h4', [_vm._v("Payout Amount")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-combobox', {
    staticStyle: {
      "max-width": "100px",
      "font-size": "20px"
    },
    attrs: {
      "items": _vm.currencies,
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.currency),
      callback: function($$v) {
        _vm.currency = $$v
      },
      expression: "currency"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "400",
      "color": "green",
      "padding-top": "7px",
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.totalPayout))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('container', [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('h4', [_vm._v("Submission Date")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "max-width": "290"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "value": _vm.submissionDateFormatted,
            "label": "",
            "prepend-icon": "mdi-calendar",
            "hint": "DD/MM/YYYY format",
            "readonly": ""
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 1854811427),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "change": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.submissionDate),
      callback: function($$v) {
        _vm.submissionDate = $$v
      },
      expression: "submissionDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Include GST 9%"
    },
    model: {
      value: (_vm.chkGST),
      callback: function($$v) {
        _vm.chkGST = $$v
      },
      expression: "chkGST"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0 pt-0"
  }, [_c('v-col', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Special Payment Terms"
    },
    model: {
      value: (_vm.chkSpecialPaymentTerms),
      callback: function($$v) {
        _vm.chkSpecialPaymentTerms = $$v
      },
      expression: "chkSpecialPaymentTerms"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-5",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('h4', [_vm._v("Remarks")]), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.invoiceRemarks),
      callback: function($$v) {
        _vm.invoiceRemarks = $$v
      },
      expression: "invoiceRemarks"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.campaignBackground),
      expression: "campaignBackground"
    }],
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("Campaign Background")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.campaignBackground))])])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.inquiryStatus) ? _c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('QandA', {
    attrs: {
      "Questions": _vm.loadAllQuestions,
      "campaignID": _vm.influencer.CampaignID,
      "influencerID": _vm.influencer.influencer_details.influencerID,
      "TriggerEmail": true,
      "pairedID": _vm.influencer.id
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.notInterestedStatus) ? _c('v-tab-item', [_c('v-card', {
    staticStyle: {
      "width": "600px",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "50px",
      "margin-bottom": "20px"
    }
  }, [_c('v-card-title', [_vm._v("Reasons")]), _vm._v(" "), _c('v-card-text', [_c('div', [(_vm.rejectReasons) ? _c('ul', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "300"
    }
  }, [(_vm.rejectReasons.campaign_proposed) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.campaign_proposed))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.campaign_timeline) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.campaign_timeline))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.payout_issue) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.payout_issue))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.competitor) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.competitor))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.not_associate) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.not_associate))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.others) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.others))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.co_reject) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.co_reject))]) : _vm._e()]) : _vm._e()])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-tab-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row"
  }, [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "width": "200"
    },
    on: {
      "click": _vm.restoreCampaignBrief
    }
  }, [_vm._v("Reset as Campaign Brief")])], 1)], 1), _vm._v(" "), _c('sun-editor', {
    staticStyle: {
      "height": "650px"
    },
    attrs: {
      "width": "100%",
      "content": _vm.briefDetailContentNew,
      "editorOpened": _vm.editorOpened,
      "source": "brief"
    },
    on: {
      "contentChanged": _vm.changeBriefContent,
      "loadingDialogOpen": _vm.loadingDialogOpen,
      "loadingDialogClose": _vm.loadingDialogClose
    }
  })], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-row', {
    staticClass: "editor-row"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "ma-1 white--text",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "color": "blue-grey"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download\n                      "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("mdi-cloud-download")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "color": "primary",
      "width": "200"
    },
    on: {
      "click": _vm.briefDetailSave
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "right": ""
    },
    on: {
      "click": _vm.closeModel
    }
  }, [_vm._v("\n                      Close\n                      ")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.acceptedStatus) ? _c('v-tab-item', [_c('v-container', {
    staticStyle: {
      "max-width": "850px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "50px",
      "margin-left": "auto,margin-right:auto"
    },
    domProps: {
      "innerHTML": _vm._s(this.briefDetail)
    }
  })])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.selectedTab === 0) ? _c('v-card-actions', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "10px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-container', [_c('div', [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.updateSubmission
    }
  }, [_vm._v("\n                    Save\n                  ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "right": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                  Close\n                  ")])], 1)])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "success",
      "rounded": "pill",
      "timeout": _vm.snackbarTimeout
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var snackattrs = ref.snackattrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, 'v-btn', snackattrs, false), [_vm._v("\n            Close\n          ")])]
      }
    }], null, false, 667378165),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbarText) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('influencer-contract-modal', {
    attrs: {
      "dialogTitle": "Invoice",
      "dialog": _vm.showContractModal,
      "close": _vm.closeInfluencerContractModal,
      "contract": _vm.influencerContract,
      "invoiceContract": _vm.invoiceContract,
      "action": _vm.upatedApproved,
      "showTerms": false,
      "showSendButton": true,
      "showSubmitButton": false,
      "showDeclineButton": false,
      "showOptions": false,
      "showCancelButton": true,
      "emailTemplateHTML": _vm.emailTemplateHTML,
      "updateEmailTemplate": _vm.updateEmailTemplate,
      "content": this.briefDetailContent,
      "briefDetailHTML": this.briefDetail,
      "users": _vm.influencer.Users || [],
      "selectedUser": _vm.selectedUser,
      "influencerEmail": _vm.influencerEmail
    }
  }), _vm._v(" "), _c('follow-up', {
    attrs: {
      "dialog": _vm.showFollowUpModal,
      "dialogClose": _vm.followUpClose,
      "from": _vm.currentUser.email,
      "fromName": _vm.currentUserFullName,
      "to": _vm.currentInfluencerEmail,
      "toName": _vm.fullName
    }
  }), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "success",
      "rounded": "pill",
      "timeout": _vm.snackbarTimeout
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var snackattrs = ref.snackattrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, 'v-btn', snackattrs, false), [_vm._v("\n        Close\n      ")])]
      }
    }]),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9d0b358"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/InfluencerDetailViewModal.vue
// module id = 2289
// module chunks = 0